import { render, staticRenderFns } from "./ProviderRoleManagement.vue?vue&type=template&id=7d2a267b&scoped=true&"
import script from "./ProviderRoleManagement.vue?vue&type=script&lang=js&"
export * from "./ProviderRoleManagement.vue?vue&type=script&lang=js&"
import style0 from "./ProviderRoleManagement.vue?vue&type=style&index=0&id=7d2a267b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2a267b",
  null
  
)

export default component.exports